/**
 * LyricScoreBar — Reusable horizontal score bar for lyric draft scores.
 */

import React from 'react';

interface LyricScoreBarProps {
  label: string;
  score: number;   // 0-10
  color?: string;   // Tailwind bg-color class
}

export const LyricScoreBar: React.FC<LyricScoreBarProps> = ({
  label,
  score,
  color = 'bg-amber-500',
}) => (
  <div className="flex items-center gap-2">
    <span className="text-[10px] text-slate-500 w-24 text-right shrink-0">{label}</span>
    <div className="flex-1 h-1.5 bg-slate-800 rounded-full overflow-hidden">
      <div
        className={`h-full rounded-full transition-all duration-500 ${color}`}
        style={{ width: `${(score / 10) * 100}%` }}
      />
    </div>
    <span className="text-[10px] font-mono text-slate-400 w-6 text-right">{score}</span>
  </div>
);
